import { Fragment, FunctionComponent, useCallback, useEffect, useState, useContext } from 'react';

import { useResizeEffect, PassiveComponentContext } from '@pp/core';

import { useRecentResultFetcher } from '../../../store/apiHooks/useRecentResultFetcher';
import { useMwGameStateSlice } from '../../../store/slices/mwGame/selectors';
import { SpinResult } from '../spinResult';

import styles from './InlineRecentResults.module.css';
import { useMWStateSlice } from '../../../store/slices/mwState/selectors';

const calculateVisibleResults = (explicitCount: number | null = null): number => {
  const maxWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth);
  const width = maxWidth;
  return explicitCount ?? Math.ceil(width / 26);
};

export interface InlineRecentResultsProps {
  explicitCount?: number;
}

export const InlineRecentResultsConnected: FunctionComponent<InlineRecentResultsProps> = ({ explicitCount }) => {
  const isPassive = useContext(PassiveComponentContext);
  const [visibleCount, setVisibleCount] = useState(calculateVisibleResults(explicitCount));
  const result = useMWStateSlice.getGameResult();
  const recentResultFetcher = useRecentResultFetcher();
  useEffect(() => {
    if (isPassive) return;
    recentResultFetcher();
  }, [recentResultFetcher]);

  const recentResults = useMwGameStateSlice.recentResults();

  useResizeEffect(
    useCallback(() => {
      const count = calculateVisibleResults(explicitCount);
      setVisibleCount(count);
    }, [])
  );

  return (
    <div className={`${styles.InlineRecentResults} ${result && styles.slideOutRight}`}>
      {!recentResults?.history
        ? Array.apply(null, Array(visibleCount)).map((_, index: number) => (
            <SpinResult key={`history_result_${index}`} id={`history_last_result_${index}`} className={styles.item} /> // NOSONAR
          ))
        : Array.apply(null, Array(visibleCount)).map((_, index: number) => (
            <Fragment key={recentResults.history[index]?.gameId ?? index}>
              <SpinResult
                id={`last_result_${index}`}
                multiplier={recentResults.history[index]?.multiplier}
                isMulti={recentResults.history[index]?.rngSlot == recentResults.history[index]?.gameResult}
                className={styles.item}
                type={recentResults.history[index]?.gameResult}
                active={index === 0}
              />
            </Fragment>
          ))}
    </div>
  );
};
